<script lang="ts" setup>
import { type OtButtonVariant } from '@1trading/design-system';
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import useLogInOut from './useLogInOut';

type LoginButton = {
  id: string;
  text: string;
  variant: OtButtonVariant;
  className: string;
  onClick: () => Promise<void> | void;
};

const { t } = useI18n({ useScope: 'global' });
const { login, signup } = useLogInOut();

const buttons = computed<Array<LoginButton>>(() => [
  {
    id: 'signup',
    text: t('modules.login.navBarSignupButtonText'),
    variant: 'primary',
    className: 'signup-button',
    onClick: signup,
  },
  {
    id: 'login',
    text: t('modules.login.navBarLoginButtonText'),
    variant: 'dark-outline',
    className: 'login-button',
    onClick: login,
  },
]);
</script>

<template>
  <div class="login-buttons">
    <x-button
      v-for="btn in buttons"
      :id="btn.id"
      :key="btn.id"
      class="login-buttons__button"
      :testid="btn.id"
      :variant="btn.variant"
      :class="btn.className"
      :text="btn.text"
      v-bind="$attrs"
      @click="btn.onClick"
    />
  </div>
</template>

<style lang="scss">
.login-buttons {
  display: flex;
  flex-direction: row-reverse;
  justify-content: space-between;
  margin: 0;
  gap: 8px;

  &__button.signup-button,
  &__button.login-button {
    flex: 1 1 0;
    margin: 0;
  }
}
</style>
